import '../Profile.css'
import Wishlist from "../Wishlist";

const WishlistPage = () => {

    return (
        <Wishlist />
    )
}

export default WishlistPage